'use strict';
const angular = require('angular');
const {extend, isDefined, isNumber, isString, noop} = angular;

export function FirebaseMqServiceProvider() {
  let TIMEOUT_ERROR = 240000; // 4 minutes

  this.defaultTimeout = function (timeout) {
    if (isNumber(timeout)) {
      TIMEOUT_ERROR = timeout;
    } else {
      return TIMEOUT_ERROR;
    }
  };

  this.$get = [
    '$log',
    '$q',
    '$timeout',
    'FirebaseUtil',
    'FirebaseConnectionService',
    function (
      $log,
      $q,
      $timeout,
      FirebaseUtil,
      FirebaseConnectionService,
    ) {
      function FirebaseMqService() {

      }

      /**
       *
       * Use options.timeout = 0 to disable the timeout
       *
       * @param request
       * @param requestCollection
       * @param responseCollection
       * @param options
       * @returns {promise}
       */
      FirebaseMqService.prototype.submitRequest = function (request, requestCollection, responseCollection, options) {

        // Assign default options
        options = extend({
          timeout: TIMEOUT_ERROR
        }, options || {});

        var deferred = $q.defer();
        var completed = false;
        var timeout;

        if (!FirebaseConnectionService.online) {
          $timeout(function () {
            deferred.reject({message: 'No connection detected. Cannot send request to server'});
          });
          return deferred.promise;
        }

        // Get push UID for the request
        var requestRef = FirebaseUtil.firebaseRef(requestCollection).push();

        // set up the response listener
        var responseRef = FirebaseUtil.firebaseRef(responseCollection + '/' + requestRef.key());
        var responseQuery = responseRef.on('value', function (ss) {
          var data = ss.val();
          var code = parseStatusCode(data !== null && data.statusCode);
          if (code) {
            //console.log('received response for ' + requestRef.key());
            fin();
            responseRef.remove(function onRemove() {
              if (code < 400) {
                deferred.resolve(data);
              } else {
                deferred.reject(data);
              }
            });
          } else if (data !== null && isDefined(data.progress)) {
            data && deferred.notify(data);
          }
        }, handleError);

        if (options.timeout) {
          timeout = $timeout(function () {
            if (!completed) handleError({
              type: 'timeout',
              message: 'timed out after ' + (options.timeout / 1000) + ' seconds'
            });
          }, options.timeout);
        }

        function handleError(error) {
          console.warn('an error occurred with the request');
          requestRef.remove();
          fin();
          deferred.reject(error);
        }

        function fin() {
          completed = true;
          responseRef.off('value', responseQuery);
          if (options.timeout) {
            try {
              $timeout.cancel(timeout);
            } catch (error) {
              // ignore
            }
          }
        }

        function parseStatusCode(code) {
          if (isNumber(code)) {
            return code;
          } else if (isString(code)) {
            const result = parseInt(code);
            if (!isNaN(result) && isNumber(result)) {
              return result;
            }
          }

          return noop(); // undefined
        }

        requestRef.set(request);

        return deferred.promise;
      };

      return new FirebaseMqService();
    }];
}



// WEBPACK FOOTER //
// ./src/js/_libs/firebase-mq/FirebaseMqService.js